import {ModuleController} from "../../infrastructure/controllers/module-controller";
import {BaseManagedService} from "../../infrastructure/domain-services/base-managed-service";
import {CompetitorPlayersStatsModuleConfig} from "./competitor-players-stats-module.config";
import {CompetitorPlayersStatsModuleStore} from "./competitor-players-stats-module.store";
import {CompetitorPlayersStatsModuleHandlers} from "./handlers/competitor-players-stats-module.handlers";
import {FullGameResponseDomainService} from "../../domain/full-game/services/full-game-response.domain-service";

export class CompetitorPlayersStatsModuleController extends ModuleController {
  static injectables = [...BaseManagedService.injectables, CompetitorPlayersStatsModuleConfig, CompetitorPlayersStatsModuleStore, CompetitorPlayersStatsModuleHandlers, FullGameResponseDomainService];
}
